<div class="avatar-placeholder-image">
  <img [src]="image || 'assets/images/avatar.svg'"/>
</div>
